{
  "#ARTIKELINFO": {
    "DIALOGS": {
      "ADD_FAVORITE_ITEM": {
        "TITLE": "Favoriten-Liste auswählen",
        "SUBTITLE": "Um den Artikel zu ihren Favoriten hinzuzufügen, wählen Sie ein bestehende Favoriten-Liste aus.",
        "CREATE_LIST_ACTION": "Neue Liste anlegen",
        "CANCEL": "Abbrechen",
        "ADD": "Hinzufügen"
      },
      "ADD_FAVORITE_LIST": {
        "TITLE": "Favoriten-Liste anlegen",
        "CANCEL": "Abbrechen",
        "ADD": "Liste erstellen"
      },
      "SAVE_EXPORT": {
        "TITLE": "Speichern & Exportieren",
        "SAVE_TITLE": "Speichern",
        "SAVE_DESC": "Wählen Sie die Liste aus in der die gescannten Artikel gespeichert werden sollen",
        "SAVE_NEW_LIST": "Neue Favoritenliste erstellen",
        "EXPORT_TITLE": "Exportieren",
        "EXPORT_DESC": "Wenn Sie die Liste als CSV-Datei per E-Mail versenden wollen, tragen Sie im Feld bitte die E-Mail Adresse des Empfängers ein",
        "CANCEL": "Abbrechen",
        "SAVE": "Speichern"
      }
    },
    "PAGES": {
      "DETAIL": {
        "ITEM_NUMBER": "Artikelnummer",
        "ARTBEZ1": "Artikelbezeichnung 1",
        "ARTBEZ2": "Artikelbezeichnung 2",
        "ARTBEZ3": "Artikelbezeichnung 3",
        "ARTBEZ4": "Artikelbezeichnung 4",
        "ARTBEZ5": "Artikelbezeichnung 5",
        "VKFORG": {
          "LISTUNG": "Listung",
          "VKFORG": "Vkforg"
        },
        "PRICES": {
          "TITLE": "Preise",
          "AMOUNT": "Staffel",
          "UNIT": "Einheit",
          "PER": "Per",
          "PRICE": "Inkl. Preis"
        },
        "STOCK": {
          "TITLE": "Lagerstände",
          "STOCK": "Lager",
          "AMOUNT": "Lagermenge",
          "DISPO": "Dispomenge",
          "ORDER_AMOUNT": "Gesamte Bestellmenge:",
          "NEXT_DELIVERY": "Nächste Lieferung: {{date}}"
        },
        "UNITS": {
          "TITLE": "Einheiten",
          "UNIT": "Einheit",
          "FACTOR": "Faktor",
          "WEIGHT": "Gewicht"
        },
        "STOCK_LOCATIONS": {
          "TITLE": "Lagerplätze"
        },
        "SUPPLIERS": {
          "TITLE": "Lieferanten",
          "MIN_ORDER_AMOUNT": "Min. Bestellmenge",
          "UNIT": "Einheit"
        },
        "OPEN_ORDERS": {
          "TITLE": "Offene Bestellungen",
          "STOCK": "Lager",
          "OPEN_AMOUNT": "Offene Bestellmenge"
        },
        "UMSATZABFRAGE": {
          "TITLE": "Umsatzabfrage",
          "START": "Abfrage starten",
          "MONTH": "Monat",
          "VALUE": "Betrag",
          "QTY": "Menge",
          "PREV_YEAR": "Vorjahr"
        }
      }
    }
  }
}
